import { createSlice } from "@reduxjs/toolkit";

interface TaskState {
  shouldRefetch: boolean;
  openTaskUuid: string | null;
}

const initialState: TaskState = {
  shouldRefetch: false,
  openTaskUuid: null,
};

const taskSlice = createSlice({
  name: "task",
  initialState,
  reducers: {
    setShouldRefetch: (state, action) => {
      state.shouldRefetch = action.payload;
    },
    resetRefetch: (state) => {
      state.shouldRefetch = false;
    },
    setOpenTaskUuid: (state, action) => {
      state.openTaskUuid = action.payload;
    },
    clearOpenTaskUuid: (state) => {
      state.openTaskUuid = null;
    },
  },
});

export const {
  setShouldRefetch,
  resetRefetch,
  setOpenTaskUuid,
  clearOpenTaskUuid,
} = taskSlice.actions;
export default taskSlice.reducer;
